/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2024-12-31 13:29:09                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-02-03 11:29:24                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * CompInfoSelectSimple: compinfo single select type
*/

/* Imports */
import Select from "react-select";
import { t } from "../../../../i18n";
/***/

/**
* CompInfoSelectSimple: compinfo single select type
* @param id - compinfo id
* @param choices - list of avaible choices
* @param values - previous selected values
* @param onChange - on change event
* @param className - Additional classNale
*/
export default function CompInfoSelectSimple({
  choices,
  values,
  onChange,
  className = ""
}: {
  choices: EasyTech.CompInfoChoice[],
  values: EasyTech.CompInfoChoice[],
  onChange: (data: EasyTech.CompInfoChoice[]) => void,
  className?: string
}) {
  /**
   * Récupère le label traduit d'un choix de compInfo selon la langue de l'utilisateur
   * @param choice - Choix contenant les traductions
   * @returns Label traduit ou label par défaut
   */
  const getTranslatedChoiceLabel = (choice: EasyTech.CompInfoChoice): string => {
    const currentLanguage = localStorage.getItem("i18nextLng") || "en";
    
    if (choice.translations && Array.isArray(choice.translations)) {
      const translation = choice.translations.find(
        (translation) => translation.language?.isoCode === currentLanguage
      );
      
      if (translation && translation.label) {
        return translation.label;
      }
    }
    
    // Fallback sur le label par défaut
    return choice.label || "";
  };

  return (
    <>
      <Select key={`${values[0]?.id || ""}`}
              options={choices.map((choice) => ({label: getTranslatedChoiceLabel(choice), value: choice}))}
              value={values[0] && {label: getTranslatedChoiceLabel(values[0]), value: values[0]}}
              menuPosition="fixed"
              classNamePrefix="react-select"
              theme={(theme) => ({
                ...theme,
                colors: {
                  ...theme.colors,
                  primary: "#41A1FF",
                },
              })}
              onChange={(e) => onChange(e ? [e.value] : [])}
              className={`min-w-0 w-full ${className}`}
              placeholder={t("common:select")}/>
    </>
  );
}
